import { GlobalController } from 'src/shared/global/GlobalController'
import ConcessionContract from './ConcessionContract'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'concessionContract',
    component: ConcessionContract,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
